export const Bio = {
  name: "Rahul Gupta",
  roles: [
    "Full Stack Developer",
    "MERN Stack Developer",
    "Python Developer",
    "Programmer",
    "Youtuber"
  ],
  description:
    "I'm a versatile software engineer with expertise in MERN stack web development. I create RESTful APIs using Node.js, Express, and Flask, and I'm proficient in Python and JavaScript. I thrive on taking on new challenges, leveraging Python scripting for data extraction and automation. My goal is to make a meaningful contribution in software development.",
  github: "https://github.com/rahulgupta020",
  resume:
    "https://drive.google.com/file/d/1VvRweWZCHjosGwTJ5D5jXhrNMDQe715T/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/rahulgupta020/",
  twitter: "https://twitter.com/rahulgupta020",
  insta: "https://www.instagram.com/rahul__gupta1998/",
  facebook: "https://www.facebook.com/profile.php?id=100009202494291",
  youtube: "https://www.youtube.com/simplesnipcode",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Android XML",
        image:
          "https://user-images.githubusercontent.com/74607521/218515659-9c9fecb9-1d89-4486-8062-14bfa0566a8b.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Flask",
        image: "https://p7.hiclipart.com/preview/654/56/983/flask-web-framework-python-software-framework-jinja-flask.jpg",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://w7.pngwing.com/pngs/925/447/png-transparent-express-js-node-js-javascript-mongodb-node-js-text-trademark-logo.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Redis",
        image: "https://logowik.com/content/uploads/images/redis.jpg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Programming Langauge",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "C++",
        image:
          "https://w7.pngwing.com/pngs/46/626/png-transparent-c-logo-the-c-programming-language-computer-icons-computer-programming-source-code-programming-miscellaneous-template-blue.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "AWS",
        image:
          "https://www.cyberark.com/wp-content/uploads/2022/01/aws-partner-interior-hero.jpeg",
      },
      {
        name: "GitLab",
        image:
          "https://yt3.googleusercontent.com/R6P5skGdZJeM1bebvt3ILeU8k-9tiqE5T198RmBH8SoGXH2gk_Lk-45uZoq6X6pW4a4c9Sqn=s900-c-k-c0x00ffffff-no-rj",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },

      {
        name: "Netlify",
        image:
          "https://cdn.iconscout.com/icon/free/png-256/free-netlify-3628945-3030170.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/C4E0BAQHWq9HBaNpGSA/company-logo_200_200/0/1603924726074?e=2147483647&v=beta&t=2_b5NJZ5JVFTq1pmiE4GP-sOor0I39556ofsrzK_tZI",
    role: "Software Engineer",
    company: "Coalescence Technologies",
    date: "Sep 2021 - Present",
    city: "Mumbai, Maharashtra, India",
    website: "https://www.coalescence.tech/",
    desc: "I work as a software engineer, specializing in backend development. I design and implement RESTful APIs using Flask and Node.js with Express.js, using MongoDB as the database. I also integrate these APIs into React.js projects for seamless frontend-backend communication. Additionally, I create Python scripts to read and analyze files, automate tasks, and scrape data from websites and mobile apps.",
    skills: [
      "Python",
      "Flask",
      "HTML",
      "CSS",
      "JavaScript",
      "NodeJs",
      "ExpressJs",
      "ReactJs",
      "MongoDB",
      "Redis",
      "Pandas",
      "Numpy",
      "AWS",
      "Gitlab",
    ],
  },
  {
    id: 1,
    img: "https://content.jdmagicbox.com/comp/mumbai/l6/022pxx22.xx22.180216222446.f5l6/catalogue/trackpoint-gps-pvt-ltd-registered-office-jogeshwari-west-mumbai-automobile-electrical-part-repair-and-services-fpp5zewnjt-250.jpg",
    role: "Tech Support Executive",
    company: "Trackpoint GPS Private Limited",
    date: "July 2018 - Aug 2020 (2 yrs 1 mos)",
    city: "Mumbai, Maharashtra, India",
    website: "https://matchpointgps.com/",
    desc: "In my role as a Tech Support Executive, I ensured the uninterrupted operation of server services, addressing server load issues by promptly restarting services and optimizing performance through data management. I also specialized in resolving escalated customer issues, offering tailored solutions by analyzing databases and creating custom queries. Additionally, I played a pivotal role in improving team productivity by developing Python scripts for automating repetitive tasks, boosting overall efficiency.    ",
    skills: [
      "Python 2.x",
      "Python 3.x",
      "Pandas",
      "Numpy",
      "Matplotlib",
      "MySQL",
      "Nagios Tool",
      "Kafla Tool",
      "Jira",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://timscdrmumbai.in/wp-content/uploads/2020/07/TIMSCDR-Header1-e1594097959343.png",
    school: "Thakur Institute of Management Studies, Career Development & Research, Mumbai",
    date: "July 2019 - May 2022",
    grade: "CGPI 8.53/10",
    desc: "I completed my post graduation at Thakur Institute of Management Studies, Career Development & Research, where I studied about development of computer applications.",
    degree: "Master of Computer Applications - MCA, Computer Programming, Specific Applications",
  },
  {
    id: 1,
    img: "https://studybharat.com/wp-content/uploads/2018/04/Shree-Shankar-Narayan-Education-Trusts-Rohidas-Patil-Institute-of-Management-Studies-Bhayandar.jpg",
    school: "Shankar Narayan College of Arts & Commerce, Mumbai",
    date: "June 2015 - May 2018",
    grade: "5.90/7",
    desc: "I completed my graduation at Shankar Narayan College of Arts & Commerce, where I studied about databases, networking, and software.",
    degree: "Bachelor of Science - BS, Information Technology",
  },
];

export const projects = [
  {
    id: 1,
    title: "Coalescence Technologies CLS-Hub-Rest Backend",
    description: "CLS-Hub is an internal project at Coalescence Technologies, featuring RESTful APIs developed in Node.js and Express, integrated with MongoDB. It enables user attendance tracking, task management, holiday entitlement monitoring, and salary slip downloads. Managers can assign tasks and change task statuses, while admins have access to all employee data and can create client invoices. This system enhances efficiency and transparency in managing various aspects of the organization's daily operations.",
    image: "https://i.postimg.cc/DfX23VkW/op2.png",
    tags: ["NodeJs", "Express", "MongoDB"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://cls-hub.coalescence.tech/",
  },
  {
    id: 2,
    title: "Coalescence Technologies CLS-Hub-Web Frontend",
    description: "CLS-Hub is an internal project at Coalescence Technologies, featuring RESTful APIs developed in Node.js and Express, integrated with MongoDB. It enables user attendance tracking, task management, holiday entitlement monitoring, and salary slip downloads. Managers can assign tasks and change task statuses, while admins have access to all employee data and can create client invoices. This system enhances efficiency and transparency in managing various aspects of the organization's daily operations.",
    image: "https://i.postimg.cc/DfX23VkW/op2.png",
    tags: ["React"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://cls-hub.coalescence.tech/",
  },
  {
    id: 3,
    title: "Coalescence Technologies Telegram Bot for Check-In Check-Out",
    description: "This project aims to create an Coalescence-Hub Management(https://cls-hub.coalescence.tech) with a Telegram bot integration. The system allows employees to check in and check out of work, request leave or work from home, and track their work hours. Admins can manage employee check-ins and check-outs, approve or reject leave requests, and send important messages and holiday notifications to employees.",
    image: "https://i.postimg.cc/hjb6RQ24/op.png",
    tags: ["Python", "Flask", "MongoDB", "python-telegram-bot", "pymongo"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 4,
    title: "Coalescence Mail Send Using Amazon SES",
    description: "This project is a Python script that allows you to send emails to clients or recipients using Amazon Simple Email Service (Amazon SES). Amazon SES is a reliable and scalable cloud-based email sending service that enables you to send transactional, marketing, and notification emails. We can Send Customize the Email Contents in HTML Form. ",
    image: "https://i.postimg.cc/Gm9n2VHr/op.png",
    tags: ["Python", "Amazon SES", "Boto3"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 5,
    title: "Ovato Blockchain Explorer",
    description: "The Ovato Blockchain Explorer is a user-friendly website that helps people understand Ovato cryptocurrency better. I worked on the frontend part from scratch and integrated it with Ovato's blockchain data. It shows real-time data like transactions and addresses, making it easy to follow what's happening.",
    image: "https://i.postimg.cc/9XZtzWG8/op.png",
    tags: ["ReactJs", "reactstrap", "react-moment", "react-chartjs-2", "react-rater", "react-autosuggest", "react-sortablejs", "Videojs"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://explorer.ovato.com/",
  },
  {
    id: 6,
    title: "Ovato",
    description: "The Ovato Website is a ReactJS project where I made significant enhancements to existing pages. While I didn't build it from the ground up, I've been actively involved in improving and customizing various aspects of the website. My work involves making changes and enhancements to deliver a better experience for visitors.",
    image: "https://i.postimg.cc/KjK3BDVh/op.png",
    tags: ["ReactJs"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://ovato.com/en",
  },
  {
    id: 7,
    title: "Scrape Data from Mobile Apps",
    description: "Our project focuses on implementing multi-processing and multi-threading techniques to efficiently crawl data from two popular food ordering mobile applications. By harnessing the power of multiple devices, we aim to gather extensive data in real-time, enhancing the speed and accuracy of our data collection process. This approach ensures that we provide up-to-date and comprehensive information, which can be valuable for market analysis and competitive insights in the food delivery industry.",
    image: "https://i.postimg.cc/MpwWH6Mm/opp.png",
    tags: ["Python", "Appium", "Appium-Python-Client", "Beautifulsoup4"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 8,
    title: "Scrape Data from Web",
    description: "The Web Scraping Aggregator project is a comprehensive effort to collect and organize data from various websites. It involves creating scrapers for multiple websites to extract specific information such as prices, product details, news articles, or any other data of interest. By centralizing this information, the project aims to provide a valuable resource for data analysis, market research, and competitive intelligence. The use of web scraping technology allows for efficient and automated data collection, enabling data-driven insights and informed decision-making.",
    image: "https://i.postimg.cc/q7gx3dWz/opp.png",
    tags: ["Python", "Selenium", "Beautifulsoup4", "Request"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 9,
    title: "Email OTP Extractor for Mobile Crawling Apps",
    description: "The Email OTP Extractor for Mobile Crawling Apps project is a Python script designed to automatically retrieve One-Time Passwords (OTPs) from email accounts and forward them to a centralized office email address. This project is crucial for managing multiple email accounts used in mobile crawling applications, where the OTPs are required for authentication and login purposes. The script extracts the most recent OTPs received in each email account.",
    image: "https://i.postimg.cc/C5v2jVw5/opp.png",
    tags: ["Python", "Selenium", "Appium", "IMAP", "BS4"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 10,
    title: "Mister Crawley - Centralized Data Management for Distributed App Crawling",
    description: "The Mister Crawley project is a Flask-based web application designed to centralize and streamline the data management process for a distributed web crawling project. With multiple laptops involved in the web crawling process, data retrieval, storage, and sharing can become complex. Mister Crawley provides a solution by serving as a centralized data hub accessible through a set of RESTful APIs deployed on an AWS EC2 instance.",
    image: "https://i.postimg.cc/wjDQ5VBd/opp.png",
    tags: ["Python", "Flask", "MongoDB", "Restful APIs", "AWS EC2", "AWS SQS"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 11,
    title: "AWS Queue Manager",
    description: "The AWS Queue Manager project is a Python script designed to manage and interact with Amazon Simple Queue Service (SQS) queues efficiently. As part of an office project, this script streamlines the process of creating, listing, retrieving information about, and managing AWS SQS queues. It provides a user-friendly command-line interface for AWS queue management tasks.",
    image: "https://i.postimg.cc/pdVTqfHS/opp.png",
    tags: ["Python", "AWS SQS", "Boto3", "AWS EC2"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },

  {
    id: 12,
    title: "Python Scripts",
    description: `
                  1) Send Email using SMTP library
                  2) Send Email using boto3 library which is Amazon SES
                  3) Delete Mail using IMAP4 library
                  4) Delete Bin Main using IMAP4 library
                  5) Move Inbox Mail in Any Lable using IMAP library
                  6) Cron For Monthly Report Generate
                  7) Cron For Send Daily Report and Excel Sheet to Client
                  8) Hourly Cron For Crawling Project
                  9) Read, Analyze, and Manipulate data from CSV files.
                  10) Read, Analyze, and Manipulate data from Excel files.
                  11) Gathering data from different files and performing tasks according to the organization requirements.
                  12) Script For AWS Queue like creating a new queue, deleting a queue, list of queue and delete message from aws queue.
                  13) Cron job for MongoDump and deletion of last month's documents in the collection. This script is required because our AWS EC2 server experienced downtime.
                  14) Reading data from MongoDB database and manipulating them according to organizational requirements.
                  15) Script for MongoDB Collection conversion into an Excel sheet using pandas.
                  16) Merge Two Excel Sheet using Pandas.
                  17) Compare Two Excel Files and Get Unique & Duplicates Values.
                  18) Convert Lat-Long into Address using Geopy
                  19) Convert Lat-Long into Address using Google API
                  20) Convert Address to Lat-Long using Google API
                  `,
    image: "https://i.postimg.cc/43mFT0bR/opp.png",
    tags: ["Python", "Pandas", "Numpy", "os", "IPython", "Pillow", "csv", "datetime", "time", "decimal", "hashlib", "json", "multiprocessing", "threading", "operator", "random", "tkinter", "appium", "apscheduler",
      "array", "boto3", "bs4", "bson", "cv2", "decorator", "dotenv", "ffmpeg", "flask", "fs", "geopy", "gettext", "getpass", "hashlib", "http", "ipaddress", "jinja2", "json", "jwt", "lazy_loader", "logging", "math",
      "matplotlib", "mongoengine", "moviepy", "psutil", "pwd", "pymongo", "redis", "requests", "schedule", "selenium", "shutil", "smtplib", "sys", "turtle", "twilio", "urllib", "virtualenv", "xlsxwriter", "xml", "zipp"
    ],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 13,
    title: "Development Environment Setup using Shell Script",
    description: "The Development Environment Setup Script automates the installation of essential tools like Python, Java, Node.js, MongoDB, Android Studio, and more. It configures environment variables and checks and displays the versions of installed components, simplifying the setup process for developers.",
    image: "https://i.postimg.cc/Gt56DsVp/op.png",
    tags: ["Bash Script"],
    category: "coalescence",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 14,
    title: "React Shopping Web App with Context API",
    description: "This is My Training Project. React Shopping Web App leverages the power of React.js and Context API to create a seamless shopping experience. Users can explore a variety of categories, including clothing, groceries, kitchen items, and accessories. To make a purchase or proceed to the checkout, users must log in with predefined credentials.    Every user starts with a wallet balance of 10,000 units, which decreases as they make purchases. This project offers a user-friendly and secure platform for online shopping, demonstrating the practical application of state management and user authentication in a modern web app.",
    image: "https://i.postimg.cc/Qdk4QjFT/op.png",
    tags: ["React.JS", "Reactstrap", "Context API"],
    category: "coalescence",
    github: "https://github.com/rahulgupta020/shopping-webapp-reactjs/",
    webapp: "https://rahulgupta020.github.io/shopping-webapp-reactjs/",
  },
  {
    id: 15,
    title: "Meme Hub",
    description: "This is My Training Project. MemeHub is a dynamic web application that allows users to search for and explore memes from the Imgflip API. It features a responsive and user-friendly interface with a real-time search bar, providing a seamless and enjoyable meme discovery experience. Users can click on meme thumbnails to view full-size images in an elegant modal interface powered by Reactstrap.",
    image: "https://i.postimg.cc/fbv2SRkd/op.png",
    tags: ["React.JS", "Reactstrap", "Axios"],
    category: "coalescence",
    github: "https://github.com/rahulgupta020/memehub/",
    webapp: "https://rahulgupta020.github.io/memehub/",
  },
  {
    id: 16,
    title: "MemeMix: Instant Meme Maker",
    description: "This is My Training Project. MemeMix is your go-to tool for creating and sharing memes in seconds. With a click, you can generate a random meme, and then unleash your creativity by adding witty captions. Customize your text with different fonts, sizes, and colors. Share your unique sense of humor with the world in no time. It's instant meme magic!",
    image: "https://i.postimg.cc/nrxtmQDV/op.png",
    tags: ["React.JS", "Reactstrap", "Axios"],
    category: "coalescence",
    github: "https://github.com/rahulgupta020/mamemaker/",
    webapp: "https://rahulgupta020.github.io/mamemaker/",
  },
  {
    id: 17,
    title: "Meme List Manager",
    description: "This is My Training Project. The Task Management App is a web-based application for organizing tasks and to-do lists. Users can create, edit, and prioritize tasks, set deadlines, and mark them as completed. It includes user authentication and provides a simple and efficient way to manage daily tasks.",
    image: "https://i.postimg.cc/RFdG0Yfs/op.png",
    tags: ["React.JS", "Reactstrap", "Axios"],
    category: "coalescence",
    github: "https://github.com/rahulgupta020/memelistmanager/",
    webapp: "https://rahulgupta020.github.io/memelistmanager/",
  },
  {
    id: 1,
    title: "Todo Web App",
    description:
      "A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://i.postimg.cc/SQT0cV3t/todo-op.png",
    tags: ["React Js", "react-google-login", "reactstrap", "Local Storage",],
    category: "personal",
    github: "https://github.com/rahulgupta020/todo-react/",
    webapp: "https://react-todoes.netlify.app/",
  },
  {
    id: 2,
    title: "College Notes Drive",
    description:
      "This is my MCA Degree project. College Notes Drive is a provide an easy approach for both students and teachers to circulate the notes whether of any kind like lecture notes, assignment questions, question papers and all the important documents.",
    image:
      "https://i.postimg.cc/sXQrXN4W/notes-op.jpg",
    tags: ["PHP", "HTML", "CSS", "Bootstrap", "MySQL"],
    category: "personal",
    github: "https://github.com/rahulgupta020/CollegeNotesDrive/",
  },
  {
    id: 2,
    title: "React Shopping Web App with Context API",
    description: "React Shopping Web App leverages the power of React.js and Context API to create a seamless shopping experience. Users can explore a variety of categories, including clothing, groceries, kitchen items, and accessories. To make a purchase or proceed to the checkout, users must log in with predefined credentials.    Every user starts with a wallet balance of 10,000 units, which decreases as they make purchases. This project offers a user-friendly and secure platform for online shopping, demonstrating the practical application of state management and user authentication in a modern web app.",
    image: "https://i.postimg.cc/Qdk4QjFT/op.png",
    tags: ["React.JS", "Reactstrap", "Context API"],
    category: "personal",
    github: "https://github.com/rahulgupta020/shopping-webapp-reactjs/",
    webapp: "https://rahulgupta020.github.io/shopping-webapp-reactjs/",
  },
  {
    id: 3,
    title: "Meme Hub",
    description: "MemeHub is a dynamic web application that allows users to search for and explore memes from the Imgflip API. It features a responsive and user-friendly interface with a real-time search bar, providing a seamless and enjoyable meme discovery experience. Users can click on meme thumbnails to view full-size images in an elegant modal interface powered by Reactstrap.",
    image: "https://i.postimg.cc/fbv2SRkd/op.png",
    tags: ["React.JS", "Reactstrap", "Axios"],
    category: "personal",
    github: "https://github.com/rahulgupta020/memehub/",
    webapp: "https://rahulgupta020.github.io/memehub/",
  },
  {
    id: 4,
    title: "MemeMix: Instant Meme Maker",
    description: "MemeMix is your go-to tool for creating and sharing memes in seconds. With a click, you can generate a random meme, and then unleash your creativity by adding witty captions. Customize your text with different fonts, sizes, and colors. Share your unique sense of humor with the world in no time. It's instant meme magic!",
    image: "https://i.postimg.cc/nrxtmQDV/op.png",
    tags: ["React.JS", "Reactstrap", "Axios"],
    category: "personal",
    github: "https://github.com/rahulgupta020/mamemaker/",
    webapp: "https://rahulgupta020.github.io/mamemaker/",
  },

  {
    id: 5,
    title: "Meme List Manager",
    description: "The Task Management App is a web-based application for organizing tasks and to-do lists. Users can create, edit, and prioritize tasks, set deadlines, and mark them as completed. It includes user authentication and provides a simple and efficient way to manage daily tasks.",
    image: "https://i.postimg.cc/RFdG0Yfs/op.png",
    tags: ["React.JS", "Reactstrap", "Axios"],
    category: "personal",
    github: "https://github.com/rahulgupta020/memelistmanager/",
    webapp: "https://rahulgupta020.github.io/memelistmanager/",
  },
  {
    id: 6,
    title: "Interactive Card Organizer",
    description: "Build an Interactive Card Organizer that allows users to create, edit, and remove cards. These cards can contain text and file attachments. Users can select or deselect cards, sort the table by various columns, and conveniently save their data in local storage for a seamless experience. This project provides an intuitive way to manage and interact with cards in a systematic manner.",
    image: "https://i.postimg.cc/B6bJWMdm/op.png",
    tags: ["React.JS", "Reactstrap", "Axios"],
    category: "personal",
    github: "https://github.com/rahulgupta020/cardorganizer/",
    webapp: "https://rahulgupta020.github.io/cardorganizer/",
  },
  {
    id: 7,
    title: "React Calculator",
    description: "Create a simple yet interactive calculator application using React. This calculator allows users to perform basic arithmetic operations like addition and subtraction. Users can input two numbers, select an operation, and see the result. The calculator also keeps track of the total number of operations performed. A reset button allows users to clear the inputs and start a new calculation. This project provides an opportunity to practice React state management, event handling, and conditional rendering while building a practical tool.",
    image: "https://i.postimg.cc/t4m6gLmF/op.png",
    tags: ["React.JS", "Reactstrap"],
    category: "personal",
    github: "https://github.com/rahulgupta020/reactcalulator",
    webapp: "https://rahulgupta020.github.io/reactcalulator/",
  },
  {
    id: 8,
    title: "Checkbox Value Mover",
    description: "Create a user-friendly web application using React that allows users to manage and move values between two boxes efficiently. The application consists of two containers, each containing a list of items with accompanying checkboxes for selection.    ",
    image: "https://i.postimg.cc/15GwxwY6/op.png",
    tags: ["React.JS", "Reactstrap"],
    category: "personal",
    github: "https://github.com/rahulgupta020/checkboxvaluemover/",
    webapp: "https://rahulgupta020.github.io/checkboxvaluemover/",
  },

  {
    id: 1,
    title: "Server Monitoring and Maintenance with Nagios and Kafka Tool",
    description: "I used Nagios and Kafka to keep a vigilant eye on our servers. I made sure everything was running smoothly, and if not, I figured out why. When space was tight, I organized data backups and cleaned house. If any server hiccuped, I was quick to reboot the service, minimizing disruptions. This project honed my knack for maintaining stable and dependable servers, making sure they're always ready to roll.    ",
    image: "https://i.postimg.cc/ZKY45cqR/op1.png",
    tags: ["Nagios", "Kafka", "MySQL"],
    category: "trackpoint",
  },
  {
    id: 2,
    title: "Python Script",
    description: `
      1) Our team sends a daily report on WhatsApp, which includes information on the total number of users who have install & logged into the app in the last week, as well as monthly and yearly summaries. To streamline this process, I have automated it using Python and Selenium.
      2) Our team monitors server services using the Nagios tool, Zookeeper Tool. Specifically, we keep an eye on server load. If the server load exceeds a certain threshold, we initiate a process to back up the data and delete data older than one month. Our database is hosted on a Cassandra server, and to facilitate this task, I have created a script that logs into the Cassandra database to check for available disk space. If the disk space is running low, it triggers the backup and deletion of older data. This script is scheduled to run as a cron job every half hour.    
      3) Our team sends a daily report, which includes both Report and Report Chart, through a Python script with a scheduled cron job. This report fetches data from both MySQL and Cassandra databases by logging in with the appropriate credentials. The report provides the following information:
          a) Total number of not reporting trackers.
          b) Trackers that have gone into sleep mode for today, the last week, the last 15 days, the last month, and those inactive for more than a month.
          c) Deactivated trackers.
          d) Trackers currently in use.
          e) The total count of installed trackers up to the present.
          f) Percentage of trackers that are not reporting.
          g) Trackers that haven't reported in the last 15 minutes, 30 minutes, 1 hour, 1 day, and 1 to 12 months.
          h) Identifying which trackers are not working and whether their respective customers have requested service.
          i) Checking if escalated service calls have been completed.      
          Additionally, the script generates beautiful charts using Matplotlib to visualize the data.      
      4) Every night, our customer support team maintains an Excel sheet with data. Customers often request changes to various fields such as ignition state, speed in kilometers per hour (kph), odometer reading, average speed, stop time, signal strength, and reason codes. To address these requests, I have created a Python script that runs at midnight. This script automates the data updates in accordance with each customer's specific requirements by executing individual update queries for each field.
      5) Essentially, each tracker is equipped with a SIM card. As part of our services, we have contracts with three different SIM providers: Airtel, Idea, and Vodafone. These SIM cards are used for two primary purposes: enabling customers to receive messages and providing internet connectivity for GPS tracking. To manage this, I've developed a Python script that runs every midnight. This script systematically evaluates each SIM card and, if necessary, replenishes the balance to ensure seamless operation.
      6) I've also written a script that assesses the total tracker sales from the previous day. Our business is associated with two key partners: HDFC and ICICI. This script helps us determine the number of trackers sold by HDFC, the number sold by ICICI, and the third category tracks sales made by our customer support team.
      7) I've developed a Flask web application for our customer support team. This app allows team members to input a user ID and configure various alerts, such as message alerts, speed alerts, parking alerts, idling alerts, towing alerts and other types of alerts, according to their needs.
      8) I've developed a python script for Convert latitude and longitude coordinates into a human-readable address & Convert an address into corresponding latitude and longitude coordinates."
      9) Collecting data from various sources, including Excel, CSV files, and URLs, and then using this data to create a pivot table and generate an analysis report.
      10) I've written a Python script to automate searching for contacts or groups, sending messages, and sending attachments in WhatsApp. I used Selenium for browser automation.
      `,
    image: "https://i.postimg.cc/T3qVJT6Q/op2.png",
    tags: ["python", "flask", "pandas", "sqlite3", "peewee", "os", "sys", "subprocess", "xlrd", "pexpect", "datetime", "time", "pytz", "geopy", "matplotlib", "socket", "csv", "requests", "json", "urllib", "pymysql", "xlsxwriter"],
    category: "trackpoint",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
